import React, { FC } from 'react';

import styles from './HistoryIcon.module.scss';

const HistoryIcon: FC= () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"
         width="168"
         height="179"
         fill="none"
         viewBox="0 0 168 179">
      <ellipse cx="84"
               cy="157.5"
               className={styles.circle}
               rx="84"
               ry="21.5" />
      <mask id="path-2-inside-1_19317_54507">
        <path fillRule="evenodd"
              d="M135.075 115.868c-.719 0-1.301.583-1.301 1.302v3.905h-3.906c-.719 0-1.302.583-1.302 1.302 0 .719.583 1.302 1.302 1.302h3.906v3.906c0 .719.582 1.302 1.301 1.302s1.302-.583 1.302-1.302v-3.906h3.906c.719 0 1.302-.583 1.302-1.302 0-.719-.583-1.302-1.302-1.302h-3.906v-3.905c0-.719-.583-1.302-1.302-1.302Z"
              clipRule="evenodd" />
      </mask>
      <path className={styles.star}
            fillRule="evenodd"
            d="M135.075 115.868c-.719 0-1.301.583-1.301 1.302v3.905h-3.906c-.719 0-1.302.583-1.302 1.302 0 .719.583 1.302 1.302 1.302h3.906v3.906c0 .719.582 1.302 1.301 1.302s1.302-.583 1.302-1.302v-3.906h3.906c.719 0 1.302-.583 1.302-1.302 0-.719-.583-1.302-1.302-1.302h-3.906v-3.905c0-.719-.583-1.302-1.302-1.302Z"
            clipRule="evenodd" />
      <path className={styles.star}
            d="M133.774 121.075v1h1v-1h-1Zm-5.208 1.302h1-1Zm5.208 1.302h1v-1h-1v1Zm2.603 0v-1h-1v1h1Zm0-2.604h-1v1h1v-1Zm-1.603-3.905c0-.167.135-.302.301-.302v-2c-1.271 0-2.301 1.031-2.301 2.302h2Zm0 3.905v-3.905h-2v3.905h2Zm-4.906 1h3.906v-2h-3.906v2Zm-.302.302c0-.166.135-.302.302-.302v-2c-1.271 0-2.302 1.031-2.302 2.302h2Zm.302.302a.3017.3017 0 0 1-.302-.302h-2c0 1.272 1.031 2.302 2.302 2.302v-2Zm3.906 0h-3.906v2h3.906v-2Zm1 4.906v-3.906h-2v3.906h2Zm.301.302a.3015.3015 0 0 1-.301-.302h-2c0 1.271 1.03 2.302 2.301 2.302v-2Zm.302-.302c0 .167-.135.302-.302.302v2c1.272 0 2.302-1.031 2.302-2.302h-2Zm0-3.906v3.906h2v-3.906h-2Zm4.906-1h-3.906v2h3.906v-2Zm.302-.302c0 .167-.135.302-.302.302v2c1.271 0 2.302-1.03 2.302-2.302h-2Zm-.302-.302c.167 0 .302.136.302.302h2c0-1.271-1.031-2.302-2.302-2.302v2Zm-3.906 0h3.906v-2h-3.906v2Zm-1-4.905v3.905h2v-3.905h-2Zm-.302-.302c.167 0 .302.135.302.302h2c0-1.271-1.03-2.302-2.302-2.302v2Z"
            mask="url(#path-2-inside-1_19317_54507)" />
      <circle cx="146.792"
              cy="100.245"
              r="4.2076"
              className={styles.roundStar}
              strokeWidth="2" />
      <circle cx="132.472"
              cy="87.2264"
              r="1.6038"
              className={styles.roundStar}
              strokeWidth="2" />
      <circle cx="28.1321"
              cy="14.3208"
              r="1.6038"
              className={styles.roundStar}
              strokeWidth="2" />
      <mask id="path-7-inside-2_19317_54507">
        <path fillRule="evenodd"
              d="M50.2641 0c-.719 0-1.3019.5829-1.3019 1.3019v3.9056h-3.9056c-.719 0-1.3019.583-1.3019 1.302 0 .719.5829 1.3018 1.3019 1.3018h3.9056v3.9057c0 .719.5829 1.3019 1.3019 1.3019.719 0 1.3019-.5829 1.3019-1.3019V7.8113h3.9057c.719 0 1.3019-.5829 1.3019-1.3019 0-.719-.5829-1.3019-1.3019-1.3019H51.566V1.302C51.566.5829 50.9831 0 50.2641 0Z"
              clipRule="evenodd" />
      </mask>
      <path className={styles.star}
            fillRule="evenodd"
            d="M50.2641 0c-.719 0-1.3019.5829-1.3019 1.3019v3.9056h-3.9056c-.719 0-1.3019.583-1.3019 1.302 0 .719.5829 1.3018 1.3019 1.3018h3.9056v3.9057c0 .719.5829 1.3019 1.3019 1.3019.719 0 1.3019-.5829 1.3019-1.3019V7.8113h3.9057c.719 0 1.3019-.5829 1.3019-1.3019 0-.719-.5829-1.3019-1.3019-1.3019H51.566V1.302C51.566.5829 50.9831 0 50.2641 0Z"
            clipRule="evenodd" />
      <path className={styles.star}
            d="M48.9622 5.2075v1h1v-1h-1Zm-5.2075 1.302h1-1Zm5.2075 1.3018h1v-1h-1v1Zm2.6038 0v-1h-1v1h1Zm0-2.6038h-1v1h1v-1ZM49.9622 1.302A.302.302 0 0 1 50.2641 1v-2c-1.2713 0-2.3019 1.0306-2.3019 2.3019h2Zm0 3.9056V1.302h-2v3.9056h2Zm-4.9056 1h3.9056v-2h-3.9056v2Zm-.3019.302a.302.302 0 0 1 .3019-.302v-2c-1.2713 0-2.3019 1.0306-2.3019 2.302h2Zm.3019.3018a.302.302 0 0 1-.3019-.3019h-2c0 1.2713 1.0306 2.302 2.3019 2.302v-2Zm3.9056 0h-3.9056v2h3.9056v-2Zm1 4.9057V7.8113h-2v3.9057h2Zm.3019.3019a.302.302 0 0 1-.3019-.3019h-2c0 1.2713 1.0306 2.3019 2.3019 2.3019v-2Zm.3019-.3019a.3019.3019 0 0 1-.3019.3019v2c1.2713 0 2.3019-1.0306 2.3019-2.3019h-2Zm0-3.9057v3.9057h2V7.8113h-2Zm4.9057-1H51.566v2h3.9057v-2Zm.3019-.3019a.302.302 0 0 1-.3019.302v2c1.2713 0 2.3019-1.0307 2.3019-2.302h-2Zm-.3019-.3019a.302.302 0 0 1 .3019.302h2c0-1.2714-1.0306-2.302-2.3019-2.302v2Zm-3.9057 0h3.9057v-2H51.566v2Zm-1-4.9056v3.9056h2V1.302h-2ZM50.2641 1a.3019.3019 0 0 1 .3019.3019h2C52.566.0306 51.5354-1 50.2641-1v2Z"
            mask="url(#path-7-inside-2_19317_54507)" />
      <mask id="path-9-inside-3_19317_54507">
        <path fillRule="evenodd"
              d="M22.9245 42.9623c-.5752 0-1.0415.4663-1.0415 1.0415v3.1245h-3.1245c-.5752 0-1.0415.4663-1.0415 1.0415 0 .5753.4663 1.0416 1.0415 1.0416h3.1245v3.1245c0 .5752.4663 1.0415 1.0415 1.0415.5752 0 1.0415-.4663 1.0415-1.0415v-3.1245h3.1246c.5752 0 1.0415-.4663 1.0415-1.0416 0-.5752-.4663-1.0415-1.0415-1.0415H23.966v-3.1245c0-.5752-.4663-1.0415-1.0415-1.0415Z"
              clipRule="evenodd" />
      </mask>
      <path className={styles.star}
            fillRule="evenodd"
            d="M22.9245 42.9623c-.5752 0-1.0415.4663-1.0415 1.0415v3.1245h-3.1245c-.5752 0-1.0415.4663-1.0415 1.0415 0 .5753.4663 1.0416 1.0415 1.0416h3.1245v3.1245c0 .5752.4663 1.0415 1.0415 1.0415.5752 0 1.0415-.4663 1.0415-1.0415v-3.1245h3.1246c.5752 0 1.0415-.4663 1.0415-1.0416 0-.5752-.4663-1.0415-1.0415-1.0415H23.966v-3.1245c0-.5752-.4663-1.0415-1.0415-1.0415Z"
            clipRule="evenodd" />
      <path className={styles.star}
            d="M21.883 47.1283v1h1v-1h-1Zm-4.166 1.0415h1-1Zm4.166 1.0416h1v-1h-1v1Zm2.083 0v-1h-1v1h1Zm0-2.0831h-1v1h1v-1Zm-1.083-3.1245a.0415.0415 0 0 1 .0415-.0415v-2c-1.1275 0-2.0415.914-2.0415 2.0415h2Zm0 3.1245v-3.1245h-2v3.1245h2Zm-4.1245 1h3.1245v-2h-3.1245v2Zm-.0415.0415a.0415.0415 0 0 1 .0415-.0415v-2c-1.1275 0-2.0415.914-2.0415 2.0415h2Zm.0415.0416a.0415.0415 0 0 1-.0415-.0416h-2c0 1.1275.914 2.0416 2.0415 2.0416v-2Zm3.1245 0h-3.1245v2h3.1245v-2Zm1 4.1245v-3.1245h-2v3.1245h2Zm.0415.0415a.0415.0415 0 0 1-.0415-.0415h-2c0 1.1275.914 2.0415 2.0415 2.0415v-2Zm.0415-.0415a.0415.0415 0 0 1-.0415.0415v2c1.1275 0 2.0415-.914 2.0415-2.0415h-2Zm0-3.1245v3.1245h2v-3.1245h-2Zm4.1246-1H23.966v2h3.1246v-2Zm.0415-.0416a.0415.0415 0 0 1-.0415.0416v2c1.1275 0 2.0415-.9141 2.0415-2.0416h-2Zm-.0415-.0415a.0415.0415 0 0 1 .0415.0415h2c0-1.1274-.914-2.0415-2.0415-2.0415v2Zm-3.1246 0h3.1246v-2H23.966v2Zm-1-4.1245v3.1245h2v-3.1245h-2Zm-.0415-.0415a.0415.0415 0 0 1 .0415.0415h2c0-1.1275-.914-2.0415-2.0415-2.0415v2Z"
            mask="url(#path-9-inside-3_19317_54507)" />
      <circle cx="13.8113"
              cy="26.0377"
              r="4.2076"
              className={styles.roundStar}
              strokeWidth="2" />
      <rect width="76.1132"
            height="104.755"
            x="44.9434"
            y="24.434"
            className={styles.skeleton}
            strokeWidth="2"
            rx="3" />
      <rect width="15.6226"
            height="40.3585"
            x="110.34"
            y="40.3585"
            className={styles.background} />
      <rect width="15.6226"
            height="39.0566"
            x="37.434"
            y="78.1132"
            className={styles.background} />
      <rect width="76.1132"
            height="104.755"
            x="44.9434"
            y="24.434"
            className={styles.skeleton}
            strokeWidth="2"
            rx="3" />
      <path className={styles.plus}
            fillRule="evenodd"
            d="M55.6603 39.0566a.781.781 0 0 0-.7811.7811v2.3434h-2.3434a.781.781 0 0 0-.7811.7811c0 .4315.3497.7812.7811.7812h2.3434v2.3434a.7812.7812 0 0 0 1.5623 0v-2.3434h2.3434a.7811.7811 0 0 0 .7811-.7812.781.781 0 0 0-.7811-.7811h-2.3434v-2.3434a.7812.7812 0 0 0-.7812-.7811Z"
            clipRule="evenodd" />
      <path className={styles.plus}
            fillRule="evenodd"
            d="M55.6603 52.0755a.781.781 0 0 0-.7811.7811V55.2h-2.3434a.7812.7812 0 0 0 0 1.5623h2.3434v2.3434a.7812.7812 0 0 0 1.5623 0v-2.3434h2.3434a.7812.7812 0 0 0 0-1.5623h-2.3434v-2.3434a.7812.7812 0 0 0-.7812-.7811Z"
            clipRule="evenodd" />
      <path className={styles.plus}
            fillRule="evenodd"
            d="M55.6603 65.0943a.7812.7812 0 0 0-.7811.7812v2.3433h-2.3434a.7812.7812 0 0 0 0 1.5623h2.3434v2.3434a.7812.7812 0 1 0 1.5623 0v-2.3434h2.3434a.7812.7812 0 0 0 0-1.5623h-2.3434v-2.3433a.7813.7813 0 0 0-.7812-.7812Z"
            clipRule="evenodd" />
      <rect width="15.6226"
            height="31.2453"
            x="110.34"
            y="40.3585"
            className={styles.background} />
      <rect width="15.6226"
            height="28.6415"
            x="37.434"
            y="82.0189"
            className={styles.background} />
      <path className={styles.filledSkeleton}
            d="M58.7849 81.2377a.7812.7812 0 0 1 0 1.5623h-6.2491a.7812.7812 0 0 1 0-1.5623h6.2491Z" />
      <path className={styles.skeleton}
            strokeWidth="2"
            d="M125.472 49.7158h-21.585c-.75 0-1.359.6082-1.359 1.3585v9.8137c0 .7502.609 1.3585 1.359 1.3585h21.585c.75 0 1.358.6082 1.358 1.3584v4.0505c0 1.1062 1.252 1.7487 2.151 1.1038l16.273-11.6742c.755-.542.755-1.6657 0-2.2077L128.981 43.203c-.899-.6448-2.151-.0024-2.151 1.1039v4.0504c0 .7503-.608 1.3585-1.358 1.3585Z" />
      <path className={styles.skeleton}
            strokeWidth="2"
            d="M35.3208 90.0743h21.5849c.7502 0 1.3585.6082 1.3585 1.3585v9.8132c0 .751-.6083 1.359-1.3585 1.359H35.3208c-.7503 0-1.3585.608-1.3585 1.358v4.051c0 1.106-1.2515 1.749-2.1504 1.104L15.5387 97.4434c-.7555-.5419-.7555-1.6656 0-2.2076l16.2732-11.6743c.8989-.6448 2.1504-.0024 2.1504 1.1038v4.0505c0 .7503.6082 1.3585 1.3585 1.3585Z" />
      <rect width="39.0566"
            height="2.6038"
            x="67.3774"
            y="41.6604"
            className={styles.title}
            rx="1.3019" />
      <path className={styles.filledSkeleton}
            d="M67.3774 55.9811c0-.719.5828-1.3019 1.3018-1.3019h27.3397v2.6038H68.6792c-.719 0-1.3018-.5829-1.3018-1.3019Z" />
      <rect width="39.0566"
            height="2.6038"
            x="67.3774"
            y="67.6981"
            className={styles.title}
            rx="1.3019" />
      <rect width="39.0566"
            height="2.6038"
            x="67.3774"
            y="93.7358"
            className={styles.title}
            rx="1.3019" />
      <rect width="39.0566"
            height="2.6038"
            x="67.3774"
            y="80.717"
            className={styles.filledSkeleton}
            rx="1.3019" />
      <rect width="39.0566"
            height="2.6038"
            x="67.3774"
            y="106.755"
            className={styles.filledSkeleton}
            rx="1.3019" />
    </svg>
  );
};

export default HistoryIcon;
